export class LoginUserDto {
  username: string;
  password: string;
  unitId?:number
  
  /**
   * 
   * @param username 
   * @param password 
   * @param unitId
   */
  constructor(username: string, password: string,unitId?:number) {
    this.username = username;
    this.password = password;
    this.unitId = unitId
  }
}